export default {
  getFontScale: () => 1
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/PixelRatio.js